import { Button } from "@chakra-ui/react";
import type { ButtonProps } from "@chakra-ui/react";
import {useTranslation} from "react-i18next";
import {FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusCircle } from "@fortawesome/free-solid-svg-icons";

export const AddRecordButton = ({className, ...props}:ButtonProps) => {
    
    const {t} = useTranslation("buttons");
    return (
        <Button 
                type="button" 
                size="sm"
                className={className}
                colorScheme="blue"
                leftIcon={<FontAwesomeIcon icon={faPlusCircle}/>}
                aria-label={t("add")}
                {...props} >{t("add")}</Button>
    );
};